
import moment from 'moment'
import Vue, { PropType } from 'vue'
import api from '@/api/api'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import SpinnerLoader from '@/components/SpinnerLoader.vue'
import { Connector, Project, ProjectType } from '@/types/main'
import { CONNECTOR_TYPES } from '@/vars/general'
import get from 'lodash/get'
import DoctorReportCard from '../components/DoctorReportCard.vue'
import DoctorReportPromoBanner from '../components/DoctorReportPromoBanner.vue'
import { DoctorReportMarkData } from '../types'
import { DOCTOR_REPORT_MARK_INFO, DOCTOR_REPORT_MARK_INFO_4H } from '../consts'
import CustomActivatorSelect from '../../../components/inputs/CustomActivatorSelect.vue'
import BaseInputOutlined from '../../../components/inputs/BaseInputOutlined.vue'
import VideoHelper from '@root/src/components/VideoHelper.vue'

export default Vue.extend({
    name: 'DoctorReport',
    components: {
        Breadcrumbs,
        SpinnerLoader,
        DoctorReportCard,
        DoctorReportPromoBanner,
        CustomActivatorSelect,
        BaseInputOutlined,
        VideoHelper
    },

    data: () => ({
        pageLoading: false,
        dashboardDataLoading: false,
        dashboardData: [],
        filialList: [] as any[],
        selectedProjectId: null as null | string,
        showVideoHelp: true
    }),
    watch: {},
    computed: {
        projectType(): ProjectType {
            return this.$store.getters.projectType;
        },
        networkProjects(): Project[] {
            return this.$store.getters.networkProjects;
        },
        pseudoNetworkProjects(): Project[] {
            return this.$store.getters.pseudoNetworkProjects;
        },
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        connector(): Connector | undefined {
            return this.project.connectors.find(el => el.connectorType === CONNECTOR_TYPES.GCB2)
        },
        is4Hands(): boolean {
            return this.connector.is4H
        },
        isVideoHintHidden(): boolean {
            return this.connector?.videoHintDisabled
        },
        breadcrumbs(): Array<any> {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'Доктор DH',
                    to: '',
                    disabled: true,
                },
            ]
        },
        marks(): DoctorReportMarkData[] {
            return Object.keys(this.dashboardData)
                .map(key => {
                    const markInfo = get(
                        this.is4Hands ? DOCTOR_REPORT_MARK_INFO_4H : DOCTOR_REPORT_MARK_INFO,
                        key
                    )
                    if (!markInfo) return
                    return { ...markInfo, id: key, value: get(this.dashboardData, key) }
                })
                .filter(el => el) as DoctorReportMarkData[]
        },
    },
    methods: {
        async initData(initital?: boolean) {
            this.dashboardDataLoading = true
            if (initital) {
                this.filialList =
                    this.projectType === 'network' ? this.networkProjects.filter(el => !el.isMain) : this.projectType === 'pseudo_network' ? this.pseudoNetworkProjects : this.networkProjects
                this.selectedProjectId = this.project.id
            }
            const { data, error } = await api.gcb2.getDoctorReportData({
                projectId: this.selectedProjectId!,
            })
            if (error) {
                this.$store.dispatch('callNotify', 'Ошибка')
            }
            this.dashboardData = data
            this.dashboardDataLoading = false
        },
        setVideoHelepVisible(value) {
            this.showVideoHelp = value
        }
    },
    async mounted() {
        this.initData(true)
    },
})
